import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  AccordionModule,
  ButtonGroupModule,
  ButtonModule,
  ButtonWrapperModule,
  CardModule,
  DropdownModule,
  EmptyContentModule,
  ExpandButtonModule,
  FilledTextFieldModule,
  IconModule,
  LegendModule,
  LoaderModule,
  MessageBoxModule,
  OverlayModule,
  SelectionListModule,
  SpinnerOverlayModule,
  TextFieldGroupModule,
  TextFieldModule,
  TooltipModule
} from './components';
import { FeatureGuideModule } from './feature-guide';
import { FileUploadModule } from './file-upload';
import {
  ButtonToggleModule,
  CheckboxModule,
  ColorPickerModule,
  DatepickerModule,
  ErrorsModule,
  InputModule,
  RadioButtonModule,
  SelectButtonModule,
  SelectModule,
  TextareaModule} from './form-controls';
import { LightboxModule } from './lightbox';
import { DomHandler } from './services';

@NgModule({
  imports: [
    AccordionModule,
    IconModule,
    CardModule,
    ButtonModule,
    ButtonGroupModule,
    ButtonWrapperModule,
    DropdownModule,
    ExpandButtonModule,
    OverlayModule,
    LoaderModule,
    SpinnerOverlayModule,
    SelectionListModule,
    LegendModule,
    TooltipModule,
    TextFieldModule,
    TextFieldGroupModule,
    FilledTextFieldModule,
    EmptyContentModule,
    MessageBoxModule,
    ErrorsModule,
    TextareaModule,
    RadioButtonModule,
    ButtonToggleModule,
    SelectButtonModule,
    CheckboxModule,
    InputModule,
    FileUploadModule,
    SelectModule,
    DatepickerModule,
    FeatureGuideModule,
    LightboxModule,
    ColorPickerModule
  ],
  exports: [
    AccordionModule,
    IconModule,
    CardModule,
    ButtonModule,
    ButtonGroupModule,
    ButtonWrapperModule,
    DropdownModule,
    ExpandButtonModule,
    OverlayModule,
    LoaderModule,
    SpinnerOverlayModule,
    SelectionListModule,
    LegendModule,
    TooltipModule,
    TextFieldModule,
    TextFieldGroupModule,
    FilledTextFieldModule,
    EmptyContentModule,
    MessageBoxModule,
    ErrorsModule,
    TextareaModule,
    RadioButtonModule,
    ButtonToggleModule,
    SelectButtonModule,
    CheckboxModule,
    InputModule,
    FileUploadModule,
    SelectModule,
    DatepickerModule,
    FeatureGuideModule,
    LightboxModule,
    ColorPickerModule
  ]
})
export class PcsComponentLibraryModule {
  static forRoot(): ModuleWithProviders<PcsComponentLibraryModule> {
    return {
      ngModule: PcsComponentLibraryModule,
      providers: [
        DomHandler
      ]
    };
  }
}
